var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeselHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6927 39.9972C25.849 39.9972 25.993 39.9498 26.1289 39.8682C26.2649 39.9498 26.4089 39.9972 26.5651 39.9972H35.0452C35.6173 39.9972 36.0839 39.3916 36.0839 38.6492V16.9049L38.8734 19.3929C39.056 19.5535 39.2569 19.6299 39.4598 19.6299C39.7925 19.6299 40.115 19.4271 40.3159 19.0427C40.6425 18.4293 40.5228 17.5868 40.0501 17.1682L21.0935 0.23695C20.7405 -0.0789832 20.2739 -0.0789832 19.9148 0.23695L0.949891 17.1763C0.477192 17.6002 0.357511 18.4374 0.684125 19.0508C1.01074 19.6642 1.6559 19.8196 2.12857 19.3957L4.9181 16.9078V38.652C4.9181 39.3945 5.38471 40 5.95681 40H14.9687C15.0255 40 15.0823 39.9868 15.1391 39.9789C15.196 39.9921 15.2528 40 15.3096 40C15.8817 40 16.3483 39.3945 16.3483 38.652V26.5202H24.658V38.652C24.658 39.3945 25.1246 40 25.6967 40L25.6927 39.9972ZM15.3056 23.8214C14.7334 23.8214 14.2668 24.427 14.2668 25.1694V37.3012H6.99582V15.0461L20.4992 2.98773L34.0025 15.0461V37.3012H26.7315V25.1694C26.7315 24.4269 26.2649 23.8214 25.6927 23.8214H15.3056Z",
    fill: "#54B4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeselHome);
export default __webpack_public_path__ + "static/media/deselHome.801ada4f0d7416f7d0999050ca4830bd.svg";
export { ForwardRef as ReactComponent };